import { SET_SELECTED_REPORT, SET_SELECTED_REPORT_BY_ID } from '../constants';

export const setSelectedReport = report => ({
  type: SET_SELECTED_REPORT,
  report,
});

export const setSelectedReportById = report => ({
  type: SET_SELECTED_REPORT_BY_ID,
  report,
});
